import { PermissionLevels } from "lib/types";

export const atLeastMember = [PermissionLevels.MEMBER, PermissionLevels.ADMIN, PermissionLevels.OWNER];
export const atLeastAdmin = [PermissionLevels.ADMIN, PermissionLevels.OWNER];
export const atLeastOwner = [PermissionLevels.OWNER];

